import { render, staticRenderFns } from "./DialogCerrarSesion.vue?vue&type=template&id=2768f45b"
import script from "./DialogCerrarSesion.vue?vue&type=script&lang=js"
export * from "./DialogCerrarSesion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports